import type { NotificationResponse } from '@monorepo/notification-common';
import { useQuery } from '@tanstack/react-query';
import {
  fetchNotificationHistory,
  fetchNotifications,
  fetchNotificationsStatus,
} from '../../utils/react-query/query-functions';
import { QUERY_KEYS } from '../../utils/react-query/query-keys';

const staleTimeMs = 5 * 60 * 1000;

export const useUserNotifications = () => {
  return useQuery<NotificationResponse[]>({
    queryKey: QUERY_KEYS.NOTIFICATIONS.LIST,
    queryFn: fetchNotifications,
    staleTime: staleTimeMs,
  });
};

export const useNotificationHistory = () => {
  return useQuery<NotificationResponse[]>({
    queryKey: QUERY_KEYS.NOTIFICATIONS.HISTORY,
    queryFn: fetchNotificationHistory,
    staleTime: staleTimeMs,
  });
};

export const useNotificationsStatus = () => {
  return useQuery<{ unread: number }>({
    queryKey: QUERY_KEYS.NOTIFICATIONS.STATUS,
    queryFn: fetchNotificationsStatus,
    staleTime: staleTimeMs,
  });
};
